import { lazy } from 'react';

export const PositionsSettingsPage = lazy(() => import('./PositionsSettingsPage'));
